import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { catchError, concatMap, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthData } from '../auth/models';
import { AuthService } from '../auth/services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService,
    private router: Router) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const idToken: AuthData | null = this.authService.getToken();
    let intReq = request;
    if (!idToken) {
      return next.handle(request);
    } else {
      intReq = request.clone({
        headers: request.headers.set("Authorization", 'Bearer ' + idToken.accessToken)
      });
      return next.handle(intReq)
        .pipe(catchError((err: HttpErrorResponse) => {
          if (err.status === 401) {
            return this.authService.refreshToken(idToken)
              .pipe(concatMap((data: any) => {
                this.authService.setToken(data);
                intReq = request.clone({
                  headers: request.headers.set("Authorization", 'Bearer ' + data.accessToken)
                });
                return next.handle(intReq)
              }),
              catchError((refreshErr: HttpErrorResponse) => {
                if (err.status === 401 || err.status === 500) {
                  this.authService.removeToken();
                  this.router.navigateByUrl("/auth/login");
                  return throwError(() => err);
                }
                return next.handle(intReq);
              })
              );

          } 
           else {
            return throwError(() => err);
          }
        }));
    }
  }


}


